// Tracking number used for ClickAndCollect methods
export const NoTracking = 'no-tracking';

export const ShippingMethods = {
    CLICK_COLLECT: 'click-collect',
    DRIVE: 'drive',
    LOCKER: 'locker'
}

export const ShippingMethodsDiscr = {
    COLISSIMO: "colissimo",
    COLISSIMO_VIA_TOOPOST: "colissimoViaToopost",
    CLICK_COLLECT: "clickAndCollect",
    DRIVE: "drive",
    BIKE: "bike",
    BPOST: "bpost",
    MONDIAL_RELAY: "mondialRelay",
    MONDIAL_RELAY_VIA_TOOPOST: "mondialRelayViaToopost",
    LOCKER: "locker",
    POSTNL: "postNL",
    BRING: "bring",
    HEAVY_DELIVERY: "heavyDelivery",
    GEODIS: "geodis",
    NSHIFT: "nshift",
    UPS: "ups",
    KN: "kuehneNagel",
    toArray() {
        return Object.values(this).filter(value => typeof value === 'string');
    }
};

export const ShippingMethodsWaybillRequired = [
    ShippingMethodsDiscr.COLISSIMO,
    ShippingMethodsDiscr.COLISSIMO_VIA_TOOPOST,
    ShippingMethodsDiscr.BPOST,
    ShippingMethodsDiscr.MONDIAL_RELAY,
    ShippingMethodsDiscr.MONDIAL_RELAY_VIA_TOOPOST,
    ShippingMethodsDiscr.POSTNL,
    ShippingMethodsDiscr.NSHIFT,
    ShippingMethodsDiscr.KN
];
